export default __webpack_public_path__ + "static/media/HOMEPAGE2.805f7f72.png";